import { RequestResponse } from "../../DTO/requestResponse";
import { Request } from "../../CONSTANTS/request";
import { MICROSERVICIOS } from "../../CONSTANTS/constants";
import * as ONLY from "is-online";
import CheckVPN from "../../../SHARED/Check-VPN";

export default class Observaciones {
  // Observaciones.BusquedaObs
  static async BusquedaObs(
    oracion: string,
    id_sucursal?: string,
    id_color?: string,
    id_tipo_ticket?: string,
    rango_fecha?: string
  ): Promise<RequestResponse> {
    console.log("oracion ", oracion);
    console.log("id_sucursal ", id_sucursal);
    console.log("id_color ", id_color);
    console.log("id_tipo_ticket ", id_tipo_ticket);
    console.log("rango_fecha ", rango_fecha);

    let busqueda: any = { palabra: oracion.trim() };

    if (id_sucursal != null) {
      let sucursal: any = { id_sucursal: id_sucursal.trim() };
      busqueda = Object.assign({}, busqueda, sucursal);
    }

    if (id_color != null) {
      let color: any = { id_color: id_color.trim() };
      busqueda = Object.assign({}, busqueda, color);
    }

    if (id_tipo_ticket != null) {
      let tipo_ticket: any = { id_tipo_ticket: id_tipo_ticket.trim() };
      busqueda = Object.assign({}, busqueda, tipo_ticket);
    }

    if (rango_fecha != null) {
      let rango_fech: any = { rango_fecha: rango_fecha.trim() };
      busqueda = Object.assign({}, busqueda, rango_fech);
    }

    let direccion = "Observaciones/search";

    if (await ONLY.default()) {
      if (await CheckVPN()) {
      // if (true) {
        return new Request(MICROSERVICIOS.BUSQUEDA_OBS).postBusquedaObs(
          direccion,
          busqueda
        );
      } else {
        return {
          status: -2,
          description:
            "No fue posible obtener información, No hay conexión con VPN",
          data: null,
          error: "No fue posible obtener información, No hay conexion con VPN",
        };
      }
    } else {
      return {
        status: -1,
        description:
          "No fue posible obtener información, No hay conexión a Internet",
        data: null,
        error: "No fue posible obtener información, No hay conexión a Internet",
      };
    }
  } //final funcion BusquedaObs
} // final clase
